/* eslint-disable no-plusplus */
/* eslint-disable no-unused-vars */
/* eslint-disable arrow-body-style */
/* eslint-disable no-continue */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable no-await-in-loop */
import { DirectboxReceive, DirectboxSend } from 'iconsax-react';
import { useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import image from '../../assets/images/image.svg';
import Center from '../../assets/styles/Center';
import EditContainer from '../../assets/styles/EditContainer';
import Text from '../../assets/styles/Text';
import CustomMidia from '../../components/CustomMidia';
import FormAuth from '../../components/FormAuth';
import Title from '../../components/Title';
import MediaUploadsService from '../../services/MediaUploadsService';
import ModelService from '../../services/ModelService';
import uploadS3 from '../../services/utils/uploadS3';
import { useStore } from '../../stores';
import * as styles from './styles';

export default function ModelMidias() {
  const [uploads, setUploads] = useState([]);
  const [medias, setMedias] = useState([]);
  const [plan, setPlan] = useState({});
  const [loadingForm, setLoadingForm] = useState(false);
  const [mediaCounts, setMediaCounts] = useState({
    photos: 0,
    videos: 0,
    total: 0,
  });
  const navigate = useNavigate();

  const { id } = useStore((state) => state.user);

  useEffect(() => {
    async function loadUploadMedia() {
      try {
        const data = await MediaUploadsService.listAllMedias(id);
        const { modelPlan } = await ModelService.findPlanModel(id);

        const mediasList = data?.urls || [];
        const counts = data?.counts || { photos: 0, videos: 0, total: 0 };

        setMedias(Array.isArray(mediasList) ? mediasList : []);
        setPlan(modelPlan || {});
        setMediaCounts(counts);
      } catch (error) {
        console.error('Erro ao carregar dados:', error);
        toast.error('Erro ao carregar imagens');
        setMedias([]);
        setPlan({});
        setMediaCounts({ photos: 0, videos: 0, total: 0 });
      }
    }

    if (id) {
      loadUploadMedia();
    }
  }, [id]);

  useEffect(() => {
    return () => {
      uploads.forEach((upload) => {
        if (upload.previewUrl) {
          URL.revokeObjectURL(upload.previewUrl);
        }
      });
    };
  }, [uploads]);

  function validateVideoDuration(file) {
    return new Promise((resolve) => {
      const video = document.createElement('video');
      video.preload = 'metadata';
      video.onloadedmetadata = () => {
        URL.revokeObjectURL(video.src);
        resolve(video.duration <= 25);
      };
      video.onerror = () => resolve(false);
      video.src = URL.createObjectURL(file);
    });
  }

  const mediasArray = Array.isArray(medias) ? medias : [];

  // Contar uploads pendentes por tipo
  const pendingPhotos = uploads.filter((upload) =>
    upload.file.type.startsWith('image/')
  ).length;
  const pendingVideos = uploads.filter((upload) =>
    upload.file.type.startsWith('video/')
  ).length;

  // Limites do plano
  const maxPhotos = plan?.plan?.maxPhotos || 0;
  const maxVideos = plan?.plan?.maxVideos || 0;

  // Total atual (já salvas + pendentes)
  const currentPhotos = mediaCounts.photos + pendingPhotos;
  const currentVideos = mediaCounts.videos + pendingVideos;

  // Disponível
  const availablePhotos = Math.max(0, maxPhotos - currentPhotos);
  const availableVideos = Math.max(0, maxVideos - currentVideos);

  // Verificar se atingiu limites
  const hasReachedPhotoLimit = currentPhotos >= maxPhotos;
  const hasReachedVideoLimit = currentVideos >= maxVideos;
  const hasReachedAllLimits = hasReachedPhotoLimit && hasReachedVideoLimit;

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: {
      'image/*': [],
      'video/*': [],
    },
    maxSize: 100 * 1024 * 1024,
    disabled: hasReachedAllLimits,
    onDrop: async (acceptedFiles) => {
      const validFiles = [];
      let photosToAdd = 0;
      let videosToAdd = 0;

      for (const file of acceptedFiles) {
        const isImage = file.type.startsWith('image/');
        const isVideo = file.type.startsWith('video/');

        // Verificar se há espaço disponível para este tipo
        if (isImage) {
          if (currentPhotos + photosToAdd >= maxPhotos) {
            toast.error(`Limite de fotos atingido (${maxPhotos} máximo)`);
            continue;
          }
        }

        if (isVideo) {
          if (currentVideos + videosToAdd >= maxVideos) {
            toast.error(`Limite de vídeos atingido (${maxVideos} máximo)`);
            continue;
          }
        }

        // Validar tamanho
        const maxImageSize = 10 * 1024 * 1024;
        const maxVideoSize = 100 * 1024 * 1024;

        if (isImage && file.size > maxImageSize) {
          toast.error(`Imagem muito grande (máx 10MB): ${file.name}`);
          continue;
        }

        if (isVideo && file.size > maxVideoSize) {
          toast.error(`Vídeo muito grande (máx 100MB): ${file.name}`);
          continue;
        }

        // Validar duração do vídeo
        if (isVideo) {
          const isValidDuration = await validateVideoDuration(file);
          if (!isValidDuration) {
            toast.error(`Vídeo muito longo (máx 25s): ${file.name}`);
            continue;
          }
        }

        // Verificar duplicados
        const alreadyExists = uploads.some(
          (upload) =>
            upload.file.name === file.name && upload.file.size === file.size
        );

        if (alreadyExists) {
          toast.error(`Arquivo duplicado: ${file.name}`);
          continue;
        }

        // Arquivo válido
        validFiles.push(file);

        if (isImage) photosToAdd++;
        if (isVideo) videosToAdd++;
      }

      if (validFiles.length === 0) {
        return;
      }

      // Criar preview URLs
      const newUploads = validFiles.map((file) => ({
        file,
        previewUrl: URL.createObjectURL(file),
        id: Date.now() + Math.random(),
      }));

      setUploads((prevState) => [...prevState, ...newUploads]);

      if (validFiles.length > 0) {
        toast.success(`${validFiles.length} arquivo(s) adicionado(s)`);
      }
    },
  });

  async function handleDeleteUpload(removingIndex) {
    setUploads((prevState) => {
      const newState = [...prevState];
      const removedUpload = newState[removingIndex];

      if (removedUpload?.previewUrl) {
        URL.revokeObjectURL(removedUpload.previewUrl);
      }

      newState.splice(removingIndex, 1);
      return newState;
    });
  }

  async function handleDeleteMedias(removingId) {
    try {
      await MediaUploadsService.deleteMedias(removingId);

      const deletedMedia = mediasArray.find((media) => media.id === removingId);

      setMedias((prevMedias) =>
        Array.isArray(prevMedias)
          ? prevMedias.filter((media) => media.id !== removingId)
          : []
      );

      if (deletedMedia) {
        setMediaCounts((prev) => ({
          photos:
            deletedMedia.mediaType === 'photo'
              ? Math.max(0, prev.photos - 1)
              : prev.photos,
          videos:
            deletedMedia.mediaType === 'video'
              ? Math.max(0, prev.videos - 1)
              : prev.videos,
          total: Math.max(0, prev.total - 1),
        }));
      }

      toast.success('Mídia removida com sucesso!');
    } catch (error) {
      console.error(error);
      toast.error('Erro ao remover mídia');
    }
  }

  async function onSubmit() {
    try {
      setLoadingForm(true);

      const uploadsUrl = await Promise.all(
        uploads.map(async ({ file }) => {
          const { url, key } = await MediaUploadsService.getPresignedMedia(
            file
          );
          return { file, url, key };
        })
      );

      const response = await Promise.allSettled(
        uploadsUrl.map(({ url, file }) => uploadS3(url, file))
      );

      await Promise.all(
        uploadsUrl.map(async (upload, index) => {
          if (response[index].status === 'fulfilled') {
            await MediaUploadsService.updatePresignedMedia(upload.key);
          }
        })
      );

      uploads.forEach((upload) => {
        if (upload.previewUrl) {
          URL.revokeObjectURL(upload.previewUrl);
        }
      });

      setUploads([]);
      toast.success('Uploads enviados com sucesso!');

      // Recarregar dados
      const data = await MediaUploadsService.listAllMedias(id);
      const mediasList = data?.urls || [];
      const counts = data?.counts || { photos: 0, videos: 0, total: 0 };

      setMedias(Array.isArray(mediasList) ? mediasList : []);
      setMediaCounts(counts);
    } catch (err) {
      console.error(err);
      toast.error(err.message || 'Erro ao enviar arquivos');
    } finally {
      setLoadingForm(false);
    }
  }

  const isFormValid = Boolean(uploads?.length > 0);

  return (
    <EditContainer>
      <Center className="center">
        <Title
          title="Faça upload para a sua galeria"
          subtitle="Mostre sua galeria para clientes"
        />

        {plan?.plan ? (
          <styles.PlanInfo>
            <Text.H3>Seu plano atual permite</Text.H3>
            <div>
              <styles.PlanImg>
                <img src={image} alt="imagem" />
                <Text.P>Fotos permitidas</Text.P>
                <Text.H4
                  $bold
                  style={{
                    color: hasReachedPhotoLimit ? '#ff4444' : 'inherit',
                  }}
                >
                  {currentPhotos}/{maxPhotos}
                </Text.H4>
                {pendingPhotos > 0 && (
                  <Text.Span style={{ fontSize: '0.8em', color: '#666' }}>
                    (+{pendingPhotos} pendente{pendingPhotos > 1 ? 's' : ''})
                  </Text.Span>
                )}
              </styles.PlanImg>

              <styles.PlanImg>
                <img src={image} alt="imagem" />
                <Text.P>Vídeos permitidos</Text.P>
                <Text.H4
                  $bold
                  style={{
                    color: hasReachedVideoLimit ? '#ff4444' : 'inherit',
                  }}
                >
                  {currentVideos}/{maxVideos}
                </Text.H4>
                {pendingVideos > 0 && (
                  <Text.Span style={{ fontSize: '0.8em', color: '#666' }}>
                    (+{pendingVideos} pendente{pendingVideos > 1 ? 's' : ''})
                  </Text.Span>
                )}
              </styles.PlanImg>
            </div>

            {hasReachedAllLimits && (
              <Text.Span
                style={{
                  color: '#ff4444',
                  fontWeight: 'bold',
                  textAlign: 'center',
                  marginTop: '10px',
                }}
              >
                Limite do plano atingido! Remova algumas mídias ou faça upgrade
                do seu plano.
              </Text.Span>
            )}

            {!hasReachedAllLimits &&
              (availablePhotos > 0 || availableVideos > 0) && (
                <Text.Span
                  style={{
                    color: '#666',
                    textAlign: 'center',
                    marginTop: '10px',
                  }}
                >
                  Disponível: {availablePhotos} foto
                  {availablePhotos !== 1 ? 's' : ''}
                  {availablePhotos > 0 && availableVideos > 0 ? ' e ' : ''}
                  {availableVideos > 0 &&
                    `${availableVideos} vídeo${
                      availableVideos !== 1 ? 's' : ''
                    }`}
                </Text.Span>
              )}
          </styles.PlanInfo>
        ) : (
          <Text.H4>Carregando plano...</Text.H4>
        )}

        <FormAuth
          buttonTitle="Atualizar galeria"
          next
          twoButtons
          formValid={isFormValid}
          isLoading={loadingForm}
          onSubmit={onSubmit}
        >
          <styles.Container
            {...getRootProps()}
            $active={isDragActive}
            style={{
              opacity: hasReachedAllLimits ? 0.5 : 1,
              cursor: hasReachedAllLimits ? 'not-allowed' : 'pointer',
              pointerEvents: hasReachedAllLimits ? 'none' : 'auto',
            }}
          >
            <input {...getInputProps()} />
            {isDragActive ? <DirectboxReceive /> : <DirectboxSend />}
            <Text.H3>
              {hasReachedAllLimits ? 'Limite atingido' : 'Enviar mídias'}
            </Text.H3>
            <Text.Span>
              {hasReachedAllLimits
                ? 'Remova algumas mídias ou faça upgrade do plano'
                : 'Fotos até 10MB e vídeos até 100MB (máx 25s)'}
            </Text.Span>
          </styles.Container>

          {uploads.length > 0 && (
            <styles.UploadPreviewList>
              {uploads.map((upload, index) => {
                const { file, previewUrl } = upload;
                const isImage = file.type.startsWith('image/');

                return (
                  <CustomMidia
                    midia={{
                      url: previewUrl,
                      mediaType: isImage ? 'photo' : 'video',
                    }}
                    key={`upload-${upload.id || index}`}
                    onDel={() => handleDeleteUpload(index)}
                    icon={false}
                    isImg={isImage}
                    index={index}
                    total={uploads.length}
                  />
                );
              })}
            </styles.UploadPreviewList>
          )}

          {mediasArray.length > 0 && (
            <styles.GaleryUploads>
              <Text.H2>Sua galeria atual</Text.H2>

              <styles.GroupGaleryUploads>
                {mediasArray.map((media) => (
                  <CustomMidia
                    midia={{
                      url: media.url,
                      mediaType: media.mediaType,
                    }}
                    key={media.id}
                    isImg={media.mediaType === 'photo'}
                    onDel={() => handleDeleteMedias(media.id)}
                  />
                ))}
              </styles.GroupGaleryUploads>
            </styles.GaleryUploads>
          )}
        </FormAuth>
      </Center>
    </EditContainer>
  );
}
